import { sendGAEvent } from '@noths/polaris-client-google-analytics';

export const trackAccordionExpanded = (selectedSection: string) => {
  sendGAEvent({
    event: 'custom_event',
    event_category: 'Footer',
    event_action: `${selectedSection} expand`,
    event_label: 'not set',
  });
};
